import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';

// Kleiner Info-Button mit Tooltip — für erklärungsbedürftige Felder im Ersteller-UI.
const InfoTip = ({ text, side = 'top', className = '' }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Erklärung anzeigen"
          onClick={(e) => e.preventDefault()}
          className={`inline-flex align-middle text-slate-400 hover:text-slate-600 focus:outline-none ${className}`}
        >
          <Info className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed">
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default InfoTip;
